<template lang="pug">
div#options_tabs.col-12.pt-3.optionTabs(v-if="showOptions")
  h5
    | {{ t("components.forms.options_tabs.title") }}
  ul.px-0.mb-0
    li(v-for="(option, index) in options" :key="index" :class="'cursor-pointer ' + optionClass(option)" @click="updateSelectedValue(option)")
      a(:id="option")
        | {{ t(`components.forms.options_selector.tol.${option}`) }}
</template>

<script>
import mixins from "common/mixins.js";
import { mapState, mapMutations } from "vuex";

export default ({
  name: 'forms-options-selector-vue',
  props: {
    options: { type: Array, default: [] },
    preSelectedOption: { type: String, default: '' },
    disableOptions: { type: Boolean, default: false}
  },
  data() {
    return {
      selectedOption: this.preSelectedOption
    }
  },
  computed: {
    ...mapState("search", ["savedOption"]),
    showOptions() {
      return this.options && this.options.length > 0;
    },
    isLoading() {
      return this.disableOptions ? 'disabled' : '';
    },
  },
  mixins: [mixins.translate],
  methods: {
    ...mapMutations("search", ["setSavedOption", "setBreadcrumbs"]),
    updateSelectedValue(option) {
      this.setBreadcrumbs([])
      if (this.selectedOption !== option) {
        this.setSavedOption(option)
        this.selectedOption = option
      }
    },
    optionClass(option) {
      if(this.selectedOption === option) {
        return this.isLoading + ' active'
      }
      return this.isLoading
    },
  },
  watch: {
    selectedOption() {
      this.$emit("update_option", this.selectedOption)
    },
    preSelectedOption() {
      this.selectedOption = this.preSelectedOption
    }
  },
  mounted() {
    if (this.preSelectedOption) {
      this.setSavedOption(this.preSelectedOption)
    }
  }
})
</script>
